import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {SummaryModel} from '../../../../../common/entity/summary.model';
import {MedicalRecordPainIntensityModel} from './medicalRecordPainIntensity.model';
import {CustomDateModel} from '../../../../../common/custom-date/entity/custom-date.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {Moment} from 'moment';
import {LovValueOrCustomValueModel} from '../../../../../common/lov/lov-value/api/model/LovValueOrCustomValue.model';
import {ConsultationSummaryModel} from "../../../../consultation/consultation/api/model/consultationSummary.model";

export class MedicalRecordPainModel implements SummaryModel {
    id: number;
    date: Moment;

    partner: PartnerSummaryModel;
    consultation: ConsultationSummaryModel;

    locations: LovValueOrCustomValueModel[];
    whens: LovValueOrCustomValueModel[];
    hows: LovValueOrCustomValueModel[];
    from: CustomDateModel;
    to: CustomDateModel;

    comment: string;
    intensities: MedicalRecordPainIntensityModel[];
    permissions: PermissionsModel;
    createdAt: Moment;

    get lastIntensity(): MedicalRecordPainIntensityModel {
        if (this.intensities?.length > 0) {
            return this.intensities.sort((a, b) => a.date.valueOf() - b.date.valueOf())[0];
        }
        return undefined;
    }


    toString(): string {
        let str = '';
        str += 'Localisation (' + this.locations?.map(value => value.label).join(', ') + ') ';
        if (!str) {
            str += 'Quand (' + this.whens?.map(value => value.label).join(', ') + ') ';
        }
        if (!str) {
            str += 'Comment (' + this.hows?.map(value => value.label).join(', ') + ') ';
        }
        return str;
    }
}
